import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { StyleProps } from './types';
import { pricingElevation } from '~app/styles/theme';

export default createMemoStyles(({ type, packageTheme }: PricingAppTheme) => ({
  RibbonStyle: {
    fontSize: 10,
    position: 'absolute',
    right: -3,
    top: -3,
    zIndex: pricingElevation.plusOne,
    overflow: 'hidden',
    width: 96,
    height: 96,
    '&:before, &:after': {
      content: "''",
      display: 'block',
      zIndex: pricingElevation.minusOne,
      backgroundColor: ({ packageName }: StyleProps) => packageTheme[packageName].primary,
      position: 'absolute',
    },
    '&:before': {
      top: 0,
      height: 3,
      width: 10,
      left: 0,
      borderTopLeftRadius: 3,
    },
    '&:after': {
      width: 3,
      height: 10,
      right: 0,
      borderBottomRightRadius: 3,
      bottom: 0,
    },
    '& p': {
      fontSize: 10,
      fontWeight: type.fontWeight.medium,
      color: '#fff',
      textAlign: 'center',
      lineHeight: '20px',
      transform: `translate(-50%, -50%) rotate(45deg) translateY(-11px)`,
      width: 184,
      display: 'block',
      boxShadow: 'none',
      position: 'absolute',
      top: '50%',
      left: '50%',
      backgroundColor: ({ packageName }) => packageTheme[packageName]?.primary,
      margin: 0,
    },
  },
}));
